import {
  COMMISSION_POLICY_PATCH_BEGIN,
  COMMISSION_POLICY_PATCH_SUCCESS,
  COMMISSION_POLICY_PATCH_FAILURE
} from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case COMMISSION_POLICY_PATCH_BEGIN:
      return {
        ...state,
        policies: {
          ...state.policies,
          patchCommissionPolicyPending: true,
          patchCommissionPolicySuccess: false,
        }
      }
      case COMMISSION_POLICY_PATCH_SUCCESS:
      return {
        ...state,
        policies: {
          ...state.policies,
          patchCommissionPolicyPending: false,
          patchCommissionPolicySuccess: true,
          patchCommissionPolicyError: null,
        }
      }
    case COMMISSION_POLICY_PATCH_FAILURE:
      return {
        ...state,
        policies: {
          ...state.policies,
          patchCommissionPolicyPending: false,
          patchCommissionPolicyError: action.data
        }
      }
    default:
      return state
  }
}
